import * as d3 from "https://cdn.jsdelivr.net/npm/d3@7/+esm";
import { feature } from "https://cdn.jsdelivr.net/npm/topojson@3/+esm";

$(function () {
	// Declare the chart dimensions and margins.
	const width = 1200;
	const height = 800;

	// You can change the colors here
	const mapColor = "#0D7680"; // map squares color
	const dotColor = "#262A33"; // circle dot color
	const dotColorHover = "#DA653C"; // circle dot hover color
	const textColor = "#FFF1E5"; // text color

	// Create the SVG container (make it responsive)
	const svg = d3
		.create("svg")
		.attr("viewBox", `0 0 ${width} ${height}`) // Set the viewBox for scaling
		.attr("preserveAspectRatio", "xMidYMid meet") // Preserve aspect ratio on resize
		.style("width", "100%") // Responsive width (100% of container)
		.style("height", "auto") // Adjust height to maintain aspect ratio
		.style("max-width", `${width}px`); // Max width to avoid overflow

	// Define a square pattern for the map fill
	svg.append("defs")
		.append("pattern")
		.attr("id", "square-pattern")
		.attr("width", 6) // Width of the pattern (grid size)
		.attr("height", 6) // Height of the pattern (grid size)
		.attr("patternUnits", "userSpaceOnUse")
		.append("rect") // Define the square
		.attr("width", 3) // Size of the squares
		.attr("height", 3) // Size of the squares
		.attr("fill", mapColor); // Color of the squares

	// Adjust the scale, translation, and rotation to shift the map slightly to the left
	const projection = d3
		.geoMercator()
		.scale((width - 100) / 2 / Math.PI)
		.translate([width / 2, height / 1.5])
		.rotate([-10, 0]); // Rotate the map slightly left (adjust the value as needed)

	// Load external data and boot
	Promise.all([d3.json("/assets/json/land50m.json"), d3.json("/assets/json/locations.json")]).then(
		function (results) {
			const data = results[0];
			const locations = results[1];
			const geoData = feature(data, data.objects.land);

			// Draw the map
			svg.append("g")
				.selectAll("path")
				.data(geoData.features)
				.join("path")
				.attr("fill", "url(#square-pattern)") // Apply the dotted pattern as the fill
				.attr("d", d3.geoPath().projection(projection))
				.style("stroke", "#FFF1E5");

			// Plot the locations as circles
			svg.append("g")
				.selectAll("circle")
				.data(locations)
				.join("circle")
				.attr("cx", (d) => projection(d.coordinates)[0]) // Project the longitude
				.attr("cy", (d) => projection(d.coordinates)[1]) // Project the latitude
				.attr("r", 10) // Initial radius of the circles
				.attr("fill", dotColor) // Color of the circles
				.attr("style", "cursor: pointer")
				.attr("class", "circle")
				.attr("stroke", (d) => d.color || "#fff") // Set stroke color from the data or default to white
				.attr("stroke-width", 1)
				.on("mouseover", function (event, d) {
					// Move the hovered circle to the top
					d3.select(this).raise(); // Bring the circle to the top

					// Change the circle color and size on hover
					d3.select(this)
						.transition() // Start transition
						.duration(300) // Transition duration in milliseconds
						.ease(d3.easeCubicInOut) // Easing effect
						.attr("r", 15) // Increase the radius
						.attr("fill", dotColorHover); // Use the dotColorHover color

					// Show the label for the hovered location
					showLabel(d);
				})
				.on("mouseout", function (event, d) {
					// Revert the circle size and color when the mouse leaves
					d3.select(this)
						.transition() // Start transition
						.duration(300) // Transition duration in milliseconds
						.ease(d3.easeCubicInOut) // Easing effect
						.attr("r", 10) // Revert to the original radius
						.attr("fill", dotColor); // Revert to default color

					// Remove any existing labels
					svg.selectAll(".label").remove();
				});

			// Function to show label on hover
			function showLabel(location) {
				// Remove any existing labels first
				svg.selectAll(".label").remove();

				const [x, y] = projection(location.coordinates);
				const padding = 20; // Set padding for the label (left and right)

				// Measure the width of the text
				const tempText = svg
					.append("text")
					.attr("x", x)
					.attr("y", y - 22)
					.attr("text-anchor", "middle")
					.attr("fill", "#FFFFFF") // Set text color to white for visibility
					.attr("class", "label")
					.text(location.name);

				const textWidth = tempText.node().getComputedTextLength(); // Measure text width
				tempText.remove(); // Remove temporary text to avoid duplication

				// Append a rectangle as the label background, dynamically setting the width
				svg.append("rect")
					.attr("x", x - textWidth / 2 - padding) // Center the rectangle relative to the text
					.attr("y", y - 40) // Position the rectangle above the circle
					.attr("width", textWidth + 2 * padding) // Set width based on text width + padding
					.attr("height", 25) // Fixed height for the label
					.attr("fill", "#0D7680") // Background color
					.attr("stroke", "#0D7680") // Border color
					.attr("class", "label")
					.attr("opacity", 0) // Start fully transparent
					.transition() // Add transition for the rectangle
					.duration(300) // Transition duration
					.ease(d3.easeCubicInOut) // Easing effect
					.attr("opacity", 1); // Fade in to full opacity

				// Now append and transition the text to ensure it appears on top
				svg.append("text")
					.attr("x", x) // Center the text
					.attr("y", y - 22) // Adjust Y position to align text vertically within the label
					.attr("text-anchor", "middle") // Center the text horizontally
					.attr("fill", "#FFFFFF") // Text color (white)
					.attr("class", "label")
					.attr("opacity", 0) // Start fully transparent
					.text(location.name)
					.transition() // Apply transition
					.duration(300) // Transition duration
					.ease(d3.easeCubicInOut) // Easing effect
					.attr("opacity", 1); // Fade in the text to full opacity
			}

			// Append the SVG element to the container
			mapContainer.append(svg.node());
		},
	);
});
